// PACKAGES
import React from 'react'
import { useParams } from 'react-router-dom'
// CONTEXTS
import { PostingProvider } from '../../contexts/PostingContext'
import { StepsProvider } from '../../contexts/StepsContext'
// COMPONENTS
import AdditionalStepsList from './AdditionalStepsList'
import AdditionalStepsReview from './AdditionalStepsReview'
// UTILS
import { REVIEW_ADDITIONAL_STEPS, CONTINUE_ADDITIONAL_STEPS } from '../../util/consts'

const AdditionalStepsProvider = () => {
  const { sectionName } = useParams()

  return (
    <>
      <StepsProvider>
        <PostingProvider>
          {sectionName === CONTINUE_ADDITIONAL_STEPS && <AdditionalStepsList />}
          {sectionName === REVIEW_ADDITIONAL_STEPS && <AdditionalStepsReview />}
        </PostingProvider>
      </StepsProvider>

    </>
  )
}

export default AdditionalStepsProvider
